import { isAxiosError } from 'axios';

export type DataQueryErrorKind = 'missing' | 'forbidden' | 'transient';

export type ClassifiedDataQueryError<TError = unknown> = {
  kind: DataQueryErrorKind;
  error: TError;
};

export const classifyDataQueryError = <TError>(
  error: TError,
): ClassifiedDataQueryError<TError> => {
  if (isAxiosError(error)) {
    if (error.response?.status === 404) {
      return { kind: 'missing', error };
    }

    if (error.response?.status === 403) {
      return { kind: 'forbidden', error };
    }
  }

  return { kind: 'transient', error };
};
